import { HeaderMenu } from "components"
import { Fragment } from "react"
import { useLocation, useSearchParams } from "react-router-dom"
import { FindByFinance } from "./components"
import { FindByInventory } from "./components/TabInventory"
import { TabNavFind } from "./components/TabNavFind"
import { TabRegisterPath } from "./types/TabRegisterPath"

type TabsSearchParams = { tabs: TabRegisterPath }

export default function Find() {
  const location = useLocation()
  const path = location?.pathname.split("/")
  const firstPath = path[1]

  const pathMapping: { [key: string]: string } = {
    accounts: "finance",
    finance: "finance",
    sales: "sales",
    purchase: "purchase",
    inventory: "inventory",
    cards: "cards",
    journals: "journals"
  }

  const result = pathMapping[firstPath] ?? "finance"
  const [searchParams, setSearchParams] = useSearchParams({
    tabs: result
  } as TabsSearchParams)

  const activeTab = searchParams.get("tabs")
  const setActiveTab = (path: string) => setSearchParams({ tabs: path })

  return (
    <Fragment>
      <section className="container my-5 flex flex-col gap-3">
        <HeaderMenu title="FIND RECORDS" />
        <TabNavFind activeTab={activeTab!} setActiveTab={setActiveTab} />
        {activeTab === "accounts" && <Fragment />}
        {activeTab === "finance" && <FindByFinance />}
        {activeTab === "sales" && <Fragment />}
        {activeTab === "purchase" && <Fragment />}
        {activeTab === "inventory" && <FindByInventory />}
        {activeTab === "cards" && <Fragment />}
        {activeTab === "journals" && <Fragment />}
      </section>
    </Fragment>
  )
}
